import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UserManagerGuard } from '../shared/guards/admin/user-manager.guard';
import { UsersComponent } from './users/users.component';
import { TemplatesComponent } from './templates/templates.component';
import { AdminComponent } from './admin.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    canActivate: [UserManagerGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewAdminRoutingModule {}
